export default __webpack_public_path__ + "static/media/banner-module0-syllabus.30ca7ff1.png";